module.exports = __webpack_public_path__ + "img/own-season.683d3d73.svg";